import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { TREND_CHANNELS } from './url-constants';

type TrendChannelsEndpointSpecification = ApiEndpointSpecification;
export const TrendChannelsEndpointSpecification: TrendChannelsEndpointSpecification = {
    url: TREND_CHANNELS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'TrendChannelsRequestParams',
    requestBodySchemaName: 'TrendChannelsRequestBody',
    okResponseSchemaName: 'TrendChannelsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 2.0,
};

export const invokeTrendChannels = Helpers.makeApiRequestFn<
    Types.TrendChannelsRequestParams,
    Types.TrendChannelsRequestBody,
    Types.TrendChannelsOkResponse
>(TrendChannelsEndpointSpecification);
